
import base from './base'; // 导入接口域名列表
import axios from "../common/axios";
import qs from 'qs'; // 根据需求是否导入qs模块

const membership = {
    // 获取预约信息--门店
    getBookingInfo(params) {
        return axios.post(`${base.sq}/gateway/shop/getBookingInfo`, params)
    },
     // F88跳转的token
    getF88ShopUrlToken(params) {
        return axios.post(`${base.sq}/gateway/shop/getF88ShopUrlToken`, params)
    },
   // 获取预约信息--会员
   getBookingInfoMember(params) {
        return axios.post(`${base.sq}/gateway/shop/getBookingInfoMember`, params)
    },
    // 获取时间
    getDateTime(params) {
        return axios.post(`${base.sq}/gateway/shop/getDateTime`, params)
    },
    // 取消预约
    deleteEmployeeBookingInfo(params) {
        return axios.post(`${base.sq}/gateway/shop/deleteEmployeeBookingInfo`, params)
    },
    // 查询店铺美容师  某个时间段被预约信息
    getUserBookingInfoByInfo(params) {
        return axios.post(`${base.sq}/gateway/shop/getUserBookingInfoByInfo`, params)
    },
    // 获取时间段
    getDateTimeList(params) {
        return axios.post(`${base.sq}/gateway/membership/getDateTimeList`, params)
    },

   // 获取时间
   getBookingDateInfo(params) {
        return axios.post(`${base.sq}/gateway/shop/getBookingDateInfo`, params)
    },
    // 获取有排班的美容师
    getEmployeeWorkInfosEmp(params) {
        return axios.post(`${base.sq}/gateway/membership/getEmployeeWorkInfosEmp`, params)
    },
    // 校验美容师有无排班和是否被预约
    checkEmployeeBooking(params) {
        return axios.post(`${base.sq}/gateway/membership/checkEmployeeBooking`, params)
    },
    // 获取有排班且无预约的美容师
    getEmployeeWorkInfosTime(params) {
        return axios.post(`${base.sq}/gateway/membership/getEmployeeWorkInfosTime`, params)
    },
    // 获取门店信息
    getStoreInfo(params) {
        return axios.post(`${base.sq}/gateway/shop/getStoreInfoByPara`, params)
    },
    //我的卡券
    myCardList(params) {
        return axios.post(`${base.sq}/gateway/card/getUserCardList`, params)
    },
   //获取美容师
   getEmployeeList(params) {
        return axios.post(`${base.sq}/gateway/membership/getEmployeeInfoBeanList`, params)
   },

  //获取美容师(分页)
  getEmployeeInfoBeanPages(params) {
        return axios.post(`${base.sq}/gateway/membership/getEmployeeInfoBeanPages`, params)
   },
      //获取排班美容师
   getEmployeeWorkInfoBeanList(params) {
        return axios.post(`${base.sq}/gateway/membership/getEmployeeWorkInfoBeanList`, params)
   },
   //新增预约
   addBooking(params) {
        return axios.post(`${base.sq}/gateway/shop/insertEmployeeBookingInfoForMobileByPara`, params)
   },
   //预约列表
   bookingList(params) {
        return axios.post(`${base.sq}/gateway/shop/getEmployeeBookingInfoByList`, params)
   },
   //待评价列表
   evaluateList(params) {
        return axios.post(`${base.sq}/gateway/shop/getEmployeeBookingInfoByList`, params)
   },
   //添加评论
   addEvaluate(params) {
        return axios.post(`${base.sq}/gateway/shop/insertBookingCommentInfo`, params)
   },
   //待评论数量
   evaluateNum(params) {
        return axios.post(`${base.sq}/gateway/shop/insertBookingCommentInfo`, params)
   },
   //消费记录
   consumeList(params) {
        return axios.post(`${base.sq}/gateway/cashier/getMasterOrderBeanList`, params)
   },
   //消费详情
   consumeInfo(params) {
        return axios.post(`${base.sq}/gateway/cashier/getMasterOrderDetailsBean`, params)
   },
   //卡券日志
   cardLogPage(params) {
        return axios.post(`${base.sq}/gateway/card/getCardLogPage`, params)
   },
   //获取员工、门店名称信息
   getStoreEmployee(params) {
        return axios.post(`${base.sq}/gateway/membership/getStoreEmployeeBean`, params)
   },
   //发送注册会员账号短信验证码
   sendMemberRegisterSms(params) {
        return axios.post(`${base.sq}/gateway/membership/sendMemberRegisterSms`, params)
   },
   //注册会员账号
   register(params) {
        return axios.post(`${base.sq}/gateway/membership/registerWeiXinMember`, params)
   },
   //判断是否是会员
   isMember(params) {
        return axios.post(`${base.sq}/gateway/membership/getMemberBaseInfo`, params)
   },
  //获取会员基础信息（不带扩展信息）
  getMemberBase(params) {
        return axios.post(`${base.sq}/gateway/membership/getMemberBase`, params)
   },
  //查询会员基础信息集合(不分页)
  getMemberBaseInfoBeanListNoPages(params) {
        return axios.post(`${base.sq}/gateway/membership/getMemberBaseInfoBeanListNoPages`, params)
   },

  //查询会员基础信息集合(不分页)--店编非必须
  getMemberBaseInfoBeanListNoPagesMobile(params) {
        return axios.post(`${base.sq}/gateway/membership/getMemberBaseInfoBeanListNoPagesMobile`, params)
   },
    //判断会员、员工、店长
    getStoreEmployeeUser(params) {
        return axios.post(`${base.sq}/gateway/membership/getStoreEmployeeUserByOpenId`, params)
   },
   //预约数
   getBookingCommentCount(params) {
        return axios.post(`${base.sq}/gateway/shop/getBookingCommentCount`, params)
   },
  //获取F88URL
  getF88ShopUrlToken(params) {
        return axios.post(`${base.sq}/gateway/shop/getF88ShopUrlToken`, params)
   },
   //老注册
   register_old(params) {
        return axios.post('https://storeapp.chlitina.com.cn/store/qrcode.php?act=other_register', params,{
              headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
   },
      //疫情调查
   epidemic_situation_survey(params) {
        return axios.post('https://storeapp.chlitina.com.cn/store/qrcode.php?act=epidemic_situation_survey', params,{
              headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })
   },


}

export default membership;




// WEBPACK FOOTER //
// ./src/service/membership.js